import { useState } from "react";

// Section helper
function Section({ label, value, children }) {
  if (!children && !value) return null;
  return (
    <div style={{ marginBottom:20 }}>
      <div style={{ fontSize:10, fontWeight:700, color:"var(--fc-text-subtle)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6 }}>{label}</div>
      {children || <div style={{ fontSize:14, color:"var(--fc-text-secondary)", lineHeight:1.7 }}>{value}</div>}
    </div>
  );
}

function ReadMore({ text, limit=300 }) {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;
  if (text.length <= limit) return <span style={{ fontSize:14, color:"var(--fc-text-secondary)", lineHeight:1.7 }}>{text}</span>;
  return (
    <span style={{ fontSize:14, color:"var(--fc-text-secondary)", lineHeight:1.7 }}>
      {expanded ? text : text.slice(0, limit) + "... "}
      <button onClick={() => setExpanded(!expanded)}
        style={{ background:"none", border:"none", cursor:"pointer", color:"#2563EB", fontWeight:600, fontSize:14, padding:0, fontFamily:"inherit" }}>
        {expanded ? "Show less" : "Read more"}
      </button>
    </span>
  );
}

export default function JobOverviewTab({ job, skills }) {
  const JOB_TYPE = { "1":"Full-time","2":"Part-time","3":"Contract","4":"Temporary","5":"Internship","6":"Freelance" };
  const loc = (job.location_requirement||"").split(",").map(s=>s.trim()).filter(Boolean).join(", ");

  return (
    <div>
      {job.job_description && (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
          <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:12 }}>
            <div style={{ width:32,height:32,borderRadius:8,background:"var(--fc-primary-light)",display:"flex",alignItems:"center",justifyContent:"center" }}>
              <i className="fa-solid fa-file-lines" style={{fontSize:13,color:"#2563EB"}}/>
            </div>
            <span style={{ fontSize:14,fontWeight:700,color:"var(--fc-text-primary)" }}>Job Description</span>
          </div>
          <div style={{ paddingLeft:40 }}><ReadMore text={job.job_description} limit={400} /></div>
        </div>
      )}
      {job.job_requirements && (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
          <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:12 }}>
            <div style={{ width:32,height:32,borderRadius:8,background:"var(--fc-amber-light)",display:"flex",alignItems:"center",justifyContent:"center" }}>
              <i className="fa-solid fa-list-check" style={{fontSize:13,color:"#D97706"}}/>
            </div>
            <span style={{ fontSize:14,fontWeight:700,color:"var(--fc-text-primary)" }}>Requirements</span>
          </div>
          <div style={{ paddingLeft:40 }}><ReadMore text={job.job_requirements} limit={400} /></div>
        </div>
      )}
      {skills.length > 0 && (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
          <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:12 }}>
            <div style={{ width:32,height:32,borderRadius:8,background:"var(--fc-green-light)",display:"flex",alignItems:"center",justifyContent:"center" }}>
              <i className="fa-solid fa-tags" style={{fontSize:13,color:"#16A34A"}}/>
            </div>
            <span style={{ fontSize:14,fontWeight:700,color:"var(--fc-text-primary)" }}>Skills Required</span>
          </div>
          <div style={{ display:"flex",flexWrap:"wrap",gap:7,paddingLeft:40 }}>
            {skills.map((s,i) => (
              <span key={i} style={{ padding:"5px 13px",background:"var(--fc-border-light)",border:"1px solid var(--fc-border)",borderRadius:99,fontSize:12,fontWeight:600,color:"var(--fc-text-secondary)" }}>{s}</span>
            ))}
          </div>
        </div>
      )}
      {job.benefits && (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
          <div style={{ display:"flex",alignItems:"center",gap:8,marginBottom:10 }}>
            <div style={{ width:32,height:32,borderRadius:8,background:"var(--fc-green-light)",display:"flex",alignItems:"center",justifyContent:"center" }}>
              <i className="fa-solid fa-gift" style={{fontSize:13,color:"#059669"}}/>
            </div>
            <span style={{ fontSize:14,fontWeight:700,color:"var(--fc-text-primary)" }}>Benefits</span>
          </div>
          <div style={{ fontSize:14,color:"var(--fc-text-secondary)",lineHeight:1.8,paddingLeft:40 }}>{job.benefits}</div>
        </div>
      )}
      {job.employer_name && job.employer_description && (
        <div style={{ background:"var(--fc-card-bg)", border:"1px solid var(--fc-border)", borderRadius:14, padding:"16px 18px", marginBottom:12 }}>
          <div style={{ fontSize:13,fontWeight:700,color:"var(--fc-text-primary)",marginBottom:8 }}>About {job.employer_name}</div>
          <div style={{ fontSize:13,color:"var(--fc-text-muted)",lineHeight:1.7 }}><ReadMore text={job.employer_description} limit={200} /></div>
          {job.employer_contact && <div style={{ fontSize:12,color:"var(--fc-text-muted)",marginTop:6 }}><i className="fa-solid fa-phone" style={{marginRight:5,color:"var(--fc-text-subtle)",fontSize:10}}/>{job.employer_contact}</div>}
          {job.employer_website && <a href={job.employer_website} target="_blank" rel="noopener noreferrer" style={{ fontSize:12,color:"#2563EB",display:"block",marginTop:4 }}><i className="fa-solid fa-globe" style={{marginRight:5,fontSize:10}}/>{job.employer_website}</a>}
        </div>
      )}
      {job.job_file_path && (
        <div style={{ marginTop:16 }}>
          <a href={job.job_file_path} target="_blank" rel="noopener noreferrer"
            style={{ display:"inline-flex",alignItems:"center",gap:7,padding:"8px 16px",borderRadius:9,background:"var(--fc-primary-light)",color:"#2563EB",fontSize:13,fontWeight:700,textDecoration:"none",border:"1px solid var(--fc-primary-border)" }}>
            <i className="fa-solid fa-download" style={{fontSize:11}}/>Download Job File
          </a>
        </div>
      )}
    </div>
  );
}